var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-line"},[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('credential',{staticStyle:{"height":"100%!important"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }